import { Text } from "@chakra-ui/react";
import React, { useState } from "react";
import { Controller } from "react-hook-form";
import AsyncSelect from "react-select/async";
import { components as RSComponents } from "react-select";

const customStyles = {
  container: (provided: any) => ({
    ...provided,
    width: "100%",
    minHeight: "40px",
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: state.isFocused ? "#f0f0f0" : "white",
    borderColor: state.isFocused ? "#007bff" : "#ccc",
    boxShadow: state.isFocused ? "0 0 5px rgba(0, 123, 255, 0.5)" : "none",
    "&:hover": {
      borderColor: "#007bff",
    },
    minHeight: "40px",
  }),
  option: (provided: any, state: any) => {
    const isFocusedColor = state.isFocused ? "#cce5ff" : "white";
    return {
      ...provided,
      backgroundColor: state.isSelected ? "#007bff" : isFocusedColor,
      color: state.isSelected ? "white" : "black",
      padding: 10,
    };
  },
  menu: (provided: any) => ({
    ...provided,
    borderRadius: "8px",
    boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
  }),
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
};

const SelectInput = (props: any) => (
  <RSComponents.Input
    {...props}
    aria-disabled={props.isDisabled}
  />
);

export type Option = {
  label: string;
  value: string | number;
};

type AsyncAutocompleteSelectProps = {
  name: string;
  control: any;
  loadOptions: (inputValue: string) => Promise<Option[]>;
  handleChange?: (val: any) => void;
  placeholder?: string;
  isClearable?: boolean;
  defaultValue?: Option | null;
  isMulti?: boolean;
  isLoading?: boolean;
  disabled?: boolean;
  triggerWithLength?: boolean
  defaultOptions?: Option[];
  closeMenuOnSelect?: boolean;
  cacheOptions?: boolean;
};

export const AsyncAutocompleteSelect: React.FC<
  AsyncAutocompleteSelectProps
> = ({
  name,
  control,
  loadOptions,
  handleChange,
  placeholder = "Selecciona...",
  isClearable = true,
  defaultValue = null,
  isMulti = false,
  isLoading,
  disabled,
  triggerWithLength = true,
  defaultOptions,
  closeMenuOnSelect = true,
  cacheOptions = true
}) => {
  const getNoOptionsMessage = () => {
    return <Text>No se encontraron coincidencias.</Text>;
  };

  const getLoadingMessage = () => {
    return <Text>Cargando...</Text>;
  };

  const [inputValue, setInputValue] = useState<string>("");

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={({ field }) => (
        <AsyncSelect
          components={{
            Input: SelectInput,
          }}
          cacheOptions={cacheOptions}
          defaultOptions={defaultOptions}
          loadOptions={loadOptions}
          onChange={(val) => {
            field.onChange(val);
            handleChange?.(val);
          }}
          closeMenuOnSelect={closeMenuOnSelect}
          value={field.value}
          placeholder={placeholder}
          isClearable={isClearable}
          styles={customStyles}
          isMulti={isMulti}
          isLoading={isLoading}
          menuPortalTarget={document.body}
          noOptionsMessage={getNoOptionsMessage}
          loadingMessage={getLoadingMessage}
          onInputChange={(val) => setInputValue(val)}
          {...(triggerWithLength
            ? {
                menuIsOpen: inputValue?.length >= 3 && !isLoading,
              }
            : {})}
          data-testid="async-autocomplete-select-input"
          isDisabled={disabled}
        />
      )}
    />
  );
};
